module.exports = __webpack_public_path__ + "img/dynamic-26.171e6459.png";